var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-3"},[_c('AffiliateProgram',{attrs:{"allowScrollContainer":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }